module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kirchleerau_AG-7c62e288e21bed43cdd2ec936ae40862.svg";